import consumer from "./consumer"

consumer.logger = console;

console.log("MessageChannel: Starting to create subscription...");

let subscription = null;
let reconnectAttempts = 0;
const maxReconnectAttempts = 3;
const reconnectDelay = 5000; // 5 seconds
let isRejected = false;
let isConnecting = false;

function createSubscription() {
  console.log("MessageChannel: Creating new subscription...");

  if (!consumer || isRejected || isConnecting) { return; }

  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }

  isConnecting = true;
  subscription = consumer.subscriptions.create("MessageChannel", {
    connected() {
      reconnectAttempts = 0;
      isRejected = false;
      isConnecting = false;
    },

    disconnected() {
      isConnecting = false;

      if (reconnectAttempts < maxReconnectAttempts && !isRejected) {
        reconnectAttempts++;

        setTimeout(() => {
          createSubscription();
        }, reconnectDelay);
      }
    },

    rejected() {
      isRejected = true;
      isConnecting = false;
    },

    received(data) {
      if (data && data.type === 'message_count_update') {
        updateMessageBadge(data.count);
      }
    }
  });

  window.messageChannelSubscription = subscription;
}

function updateMessageBadge(count) {
  const menuItem = document.querySelector("#messages-menu-item");

  if (!menuItem) {
    return;
  }

  let badgeElement = menuItem.querySelector(".badge");

  if (count > 0) {
    if (badgeElement) {
      badgeElement.textContent = count;
      badgeElement.style.display = "inline";
    } else {
      const newBadge = document.createElement("span");
      newBadge.className = "badge badge-danger";
      newBadge.textContent = count;
      menuItem.appendChild(newBadge);
    }
  } else {
    if (badgeElement) {
      badgeElement.style.display = "none";
    }
  }
}

// Check if user is logged in before starting WebSocket
async function checkUserAuthentication() {
  try {
    const response = await fetch('/message/message_count', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    });

    // Handle network or server errors (e.g., 500)
    if (!response.ok) {
      return false;
    }

    const data = await response.json();

    // The key check: rely on the JSON payload, not the HTTP status code.
    if (data && data.authenticated) {
      return true;
    } else {
      return false;
    }

  } catch (error) {
    return false;
  }
}

// Only start WebSocket if user is authenticated
checkUserAuthentication().then(isAuthenticated => {
  if (isAuthenticated) {
    createSubscription();
  }
});
